import o from "./CdrFormError.vue2.mjs";
import r from "./styles/CdrFormError.module.scss.mjs";
import s from "../../../_virtual/_plugin-vue_export-helper.mjs";
const t = {
  $style: r
}, f = /* @__PURE__ */ s(o, [["__cssModules", t]]);
export {
  f as default
};
